module.exports = __webpack_public_path__ + "static/media/placeholder_5.7a2451a1.jpg";